import { ILegacyFullStockObject } from '@classes/legacy-full-stock-object';
import { LegacyProductModel } from '@classes/legacy-product-model';

import { flow, groupBy, map, sortBy, toArray, uniqBy } from 'lodash';

/**
 * Class that encompase a set of legacy product stock, and exposes some methods
 * to work with data.
 */
export class LegacyProductList {
  constructor(private rawStock: ILegacyFullStockObject[]) {}

  /**
   * Return array of sizes that appears on the list
   * @return {string[]}
   * All sizes in order
   */
  // TODO CORE-1722 remove code duplication
  getSizes(): string[] {
    return flow([
      (x) => uniqBy(x, 'size'),
      (x) => sortBy(x, 'sizeindex'),
      (x) => map(x, (x) => x.size),
    ])(this.rawStock);
  }

  /**
   * Gives a list transfromed data
   * @return {LegacyProductModel[]}
   * List of LegacyProductsModels to be displayed
   */
  get(): LegacyProductModel[] {
    const groupedStock = groupBy(
      this.rawStock,
      (value: ILegacyFullStockObject) =>
        JSON.stringify({
          shop: value.shop,
          maincolor: value.maincolor,
          subcolor: value.subcolor,
          suppliercolor: value.suppliercolor,
        }),
    );

    return map(toArray(groupedStock), (stock) => {
      const legacyProduct = new LegacyProductModel();

      legacyProduct.setFromStock(stock);

      return legacyProduct;
    });
  }
}
